// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Stack, Group } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconArrowLeft, IconRocket, IconCloud, IconDevices, IconBolt, IconMail, IconUser, IconColumns } from '@tabler/icons-react';
import { FadeIn, SlideIn } from '@/components/animations';
import { SplitScreenLayout, SocialLoginButtons, PasswordStrength } from '../components';

const features = [
  {
    icon: <IconRocket size={20} />,
    title: 'Quick Setup',
    description: 'Get started in minutes, not hours',
  },
  {
    icon: <IconCloud size={20} />,
    title: 'Cloud Sync',
    description: 'Access your data from anywhere',
  },
  {
    icon: <IconDevices size={20} />,
    title: 'Multi-Platform',
    description: 'Works on all your devices',
  },
  {
    icon: <IconBolt size={20} />,
    title: 'Lightning Fast',
    description: 'Optimized for performance',
  },
];

export default function RegisterSplitScreen() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [agreeTerms, setAgreeTerms] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Register:', { name, email, password });
  };

  return (
    <SplitScreenLayout
      ratio="40-60"
      leftContentType="features"
      gradientFrom="cyan"
      gradientTo="teal"
      title="Start Your Journey"
      subtitle="Join thousands of teams already using our platform to boost their productivity."
      features={features}
      badgeText="Free Trial"
      badgeColor="cyan"
    >
      <Container size="xs" w="100%">
        <Stack gap="lg">
          <Button
            component={Link}
            to="/app/demo/auth-pages/register"
            variant="subtle"
            size="xs"
            leftSection={<IconArrowLeft size={14} />}
            w="fit-content"
          >
            Back to variants
          </Button>

          <FadeIn delay={100}>
            <Stack gap="xs" align="center">
              <Badge
                leftSection={<IconColumns size={12} />}
                variant="gradient"
                gradient={{ from: 'cyan', to: 'teal' }}
                size="lg"
              >
                Split Screen
              </Badge>
              <Title order={2} ta="center" mt="md">
                Create your account
              </Title>
              <Text c="dimmed" size="sm" ta="center">
                Start your 14-day free trial. No credit card required.
              </Text>
            </Stack>
          </FadeIn>

          <SlideIn direction="up" delay={200}>
            <form onSubmit={handleSubmit}>
              <Stack gap="md">
                <TextInput
                  label="Full name"
                  placeholder="John Doe"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  leftSection={<IconUser size={16} />}
                  required
                />

                <TextInput
                  label="Email address"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  leftSection={<IconMail size={16} />}
                  required
                />

                <PasswordInput
                  label="Password"
                  placeholder="Create a strong password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                {password && <PasswordStrength password={password} variant="bars" />}

                <PasswordInput
                  label="Confirm password"
                  placeholder="Confirm your password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  error={confirmPassword && password !== confirmPassword ? 'Passwords do not match' : undefined}
                />

                <Checkbox
                  label={
                    <Text size="sm">
                      I agree to the{' '}
                      <Anchor component={Link} to="#" fw={500}>Terms of Service</Anchor>
                      {' '}and{' '}
                      <Anchor component={Link} to="#" fw={500}>Privacy Policy</Anchor>
                    </Text>
                  }
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.currentTarget.checked)}
                />

                <Button
                  type="submit"
                  fullWidth
                  size="md"
                  variant="gradient"
                  gradient={{ from: 'cyan', to: 'teal' }}
                  disabled={!agreeTerms}
                >
                  Create account
                </Button>
              </Stack>
            </form>
          </SlideIn>

          <FadeIn delay={300}>
            <Stack gap="md">
              <Text ta="center" size="sm" c="dimmed">
                Or sign up with
              </Text>
              <SocialLoginButtons providers={['google', 'github', 'microsoft']} layout="row" />
            </Stack>
          </FadeIn>

          <FadeIn delay={400}>
            <Text ta="center" size="sm" c="dimmed">
              Already have an account?{' '}
              <Anchor component={Link} to="/app/demo/auth-pages/login/splitscreen" fw={500}>
                Sign in
              </Anchor>
            </Text>
          </FadeIn>
        </Stack>
      </Container>
    </SplitScreenLayout>
  );
}
